import { useCallback } from 'react';
// sau thay bằng libphonenumber-js
const normalizeVietnamPhone = (phone?: string) => {
  if (!phone) return '';
  // Bỏ ký tự thừa
  let cleaned = phone.replace(/[^0-9+]/g, '');
  // Nếu bắt đầu bằng 0 → đổi thành +84
  if (cleaned.startsWith('0')) {
    cleaned = '+84' + cleaned.slice(1);
  }
  // Nếu bắt đầu bằng 84 → thêm +
  if (cleaned.startsWith('84') && !cleaned.startsWith('+84')) {
    cleaned = '+' + cleaned;
  }
  return cleaned;
};

export const usePhoneFormat = () => {
  const normalizePhone = useCallback((phone?: string) => {
    return normalizeVietnamPhone(phone);
  }, []);
  const formatPhone = useCallback((phone?: string) => {
    const normalized = normalizeVietnamPhone(phone);
    if (!normalized.startsWith('+84')) return normalized;
    const nationalNumber = normalized.slice(3);
    return `(+84) ${nationalNumber}`;
  }, []);
  const isValidPhone = useCallback((phone?: string) => {
    const normalized = normalizeVietnamPhone(phone);
    // +84 + 9 số phía sau (mobile VN thường 10 số tổng)
    const regex = /^\+84\d{9}$/;
    return regex.test(normalized);
  }, []);
  return {
    normalizePhone,
    formatPhone,
    isValidPhone,
  };
};
